import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from 'src/components/ui/dialog';
import { Loader2 } from 'lucide-react';
import { portalDs } from 'src/components/portal-design-system';
import { cn } from 'src/lib/utils';

interface CampaignEmailPreviewModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  html: string | null;
  isLoading: boolean;
  error: string | null;
  scheduleName?: string;
}

export function CampaignEmailPreviewModal({
  open,
  onOpenChange,
  html,
  isLoading,
  error,
  scheduleName,
}: CampaignEmailPreviewModalProps) {
  return (
    <Dialog
      open={open}
      onOpenChange={onOpenChange}
    >
      <DialogContent className="flex max-h-[90vh] max-w-4xl flex-col gap-0 overflow-hidden bg-white p-0">
        <DialogHeader className="border-b border-[#EDEEF2] bg-white px-6 py-4">
          <DialogTitle>
            Email preview
          </DialogTitle>
          <DialogDescription>
            {scheduleName
              ? `Preview of "${scheduleName}" as recipients will receive it.`
              : 'Preview of the campaign performance email.'}
          </DialogDescription>
        </DialogHeader>

        <div className="min-h-[320px] flex-1 overflow-y-auto bg-white p-6">
          {isLoading ? (
            <div className="flex items-center justify-center gap-2 py-16 text-[#5E6278]">
              <Loader2
                className="size-5 animate-spin"
                aria-hidden
              />
              <span className={portalDs.bodySm}>
                Rendering preview…
              </span>
            </div>
          ) : null}

          {!isLoading && error ? (
            <p
              className={cn(portalDs.bodySm, 'text-[#DC2626]')}
              role="alert"
            >
              {error}
            </p>
          ) : null}

          {!isLoading && !error && html ? (
            <div
              className="mx-auto max-w-3xl overflow-hidden rounded-xl border border-[#EDEEF2] bg-white shadow-sm"
              data-testid="campaign-email-preview-frame"
            >
              <iframe
                title="Campaign email preview"
                srcDoc={html}
                className="min-h-[640px] w-full border-0"
                sandbox=""
              />
            </div>
          ) : null}
        </div>
      </DialogContent>
    </Dialog>
  );
}
